import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface UpdateNoteData {
  id: string
  title?: string
  content?: string
  contactAccountId?: string | null // null for personal notes, accountId for shared notes
  scope?: string
  isShared?: boolean
}

const updateNote = async (data: UpdateNoteData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/note/${id}`, {
    title: updateData.title,
    content: updateData.content,
    contactAccountId: updateData.contactAccountId,
    scope: updateData.scope,
    isShared: updateData.isShared,
  })
}

export const useUpdateNote = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, UpdateNoteData>({
    mutationFn: updateNote,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.noteUpdated'))
      await queryClient.invalidateQueries({ queryKey: ['notes'] })
    },
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}

